






















































































import {
  Vue, Prop, Component, Emit,
} from 'vue-property-decorator';
import MainButton from '@/shared/buttons/main-button.component.vue';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import TaskService from '@/domain/task/task.service';
import ModalComponent from '@/shared/modal/modal.component.vue';
import DateFormat from '@/shared/utils/date-format';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import BillingService from '../../../domain/billing/service/billing.service';

@Component({
  components: {
    MainButton,
    LabelSlot,
    ModalComponent,
  },
  filters: {
    monthYear(value: string): string {
      const date: string = DateFormat.localDateToLocal(value);
      return DateFormat.fullMonthAndYear(date);
    },
  },
})
export default class BillingModalExecute extends Vue {
  @Prop({
    required: true,
  })
  showModal!: boolean;

  @Prop({
    required: true,
  })
  businessUnitId!: string;

  competence: string = '';

  pickerMenu: boolean = false;

  loading: boolean = false;

  executionId: string = '';

  created() {
    this.setPastMonthCompetence();
  }

  get pastMonth(): string {
    const date: Date = new Date();
    date.setDate(1);
    date.setMonth(date.getMonth() - 1);
    return new Date(date).toISOString().substr(0, 7);
  }

  get modalState() {
    return this.showModal;
  }

  set modalState(value: boolean) {
    this.$emit('updateModalState', value);
  }

  setPastMonthCompetence(): void {
    this.competence = this.pastMonth;
  }

  startLoading(): void {
    this.loading = true;
  }

  stopLoading(): void {
    this.loading = false;
  }

  @Emit('filterByCompetence')
  filterByCompetence(): string {
    return DateFormat.localDateToLocal(this.competence);
  }

  executeBilling(): void {
    this.startLoading();
    BillingService.executeBilling({
      businessUnitId: this.businessUnitId,
      invoiceCompetence: this.competence,
      billingDaily: false,
    })
      .then((taskId: string) => this.handleExecuteBilling(taskId))
      .catch(this.handleError);
  }

  private handleExecuteBilling(taskId: string) {
    TaskService.getTask(taskId, 10000)
      .then(() => this.handleExecutionSuccess())
      .catch((err) => this.handleError(err));
  }

  private handleExecutionSuccess() {
    this.modalState = false;
    this.filterByCompetence();
  }

  private handleError(err: any) {
    this.stopLoading();
    VbSnackbarService.handleHttpError(err);
    this.$emit('executionError')
  }
}
